module.exports = __webpack_public_path__ + "img/great.601b2468.svg";